<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<app-header-card [title]="this.tournament?.name ?? 'Tournament'">
  <button mat-raised-button color="primary" [routerLink]="'..'">Back to Overview</button>
</app-header-card>

@if (teams().length > 0) {
  <div class="table-container" data-cy="beer-pong-tables-list">
    <table
      mat-table
      [dataSource]="teams()"
      class="mat-elevation-z8"
      data-cy="tournament-team-table"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{ asTeamDto(element).name }}</td>
      </ng-container>
      <ng-container matColumnDef="checkedIn">
        <th mat-header-cell *matHeaderCellDef>Ready</th>
        <td mat-cell *matCellDef="let element">
          @if (asTeamDto(element).checkedIn) {
            <mat-chip class="chip-success">
              <mat-icon matChipTrailingIcon>check</mat-icon>
              Ready
            </mat-chip>
          } @else {
            <mat-chip class="chip-warn">
              <mat-icon matChipTrailingIcon>close</mat-icon>
              Not ready
            </mat-chip>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            (click)="checkInTeam(element)"
            data-cy="tournament-team-checkin-btn"
            [disabled]="element.checkedIn"
            [matTooltip]="'Mark team as ready'"
          >
            <mat-icon>waving_hand</mat-icon>
          </button>
          <button
            mat-icon-button
            data-cy="edit-team-btn"
            (click)="openTeamEditDialog(element)"
            [matTooltip]="'Edit team'"
            data-cy="tournament-team-edit-btn"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            [matTooltip]="'Delete team'"
            (click)="deleteTeam(element)"
            data-cy="tournament-team-delete-btn"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
} @else {
  <div class="no-teams-message">
    <h2>No teams have registered yet!</h2>
    <h3><a [routerLink]="'..'">Return to overview</a></h3>
  </div>
}
